import { useBunja } from 'bunja/react';
import { useAtom } from 'jotai';
import { useTranslations } from 'next-intl';
import { use } from 'react';

import { FormattedMessage } from '@flipster/i18n';
import { useOverlayItem } from '@flipster/overlay';
import { IconButton } from '@flipster/react/design-system/icon-button';
import { TextButton } from '@flipster/react/design-system/text-button';
import { hstack, stack } from '@flipster/styled-system/patterns';
import { Search } from '@flipster/ui';
import DocumentHistoryIcon from '@flipster/ui/assets/svgs/document-history.svg';

import { WalletModalTypeContext } from '../core/state';
import { selectAssetBunja } from './state';

export const Header = () => {
  const type = use(WalletModalTypeContext);
  const t = useTranslations();
  const { close } = useOverlayItem();
  const { keywordAtom } = useBunja(selectAssetBunja);
  const [keyword, setKeyword] = useAtom(keywordAtom);
  return (
    <div className={stack({ gap: 24, w: '100%' })}>
      <div className={hstack({ justify: 'space-between' })}>
        <h2>
          <FormattedMessage id='Select_asset.r250401.Select_asset' />
        </h2>
        {type === 'deposit' && (
          <div className={hstack({ gap: 20 })}>
            <TextButton color='neutral' size='large' label='FAQ' as='a' href='/faq/deposit' newTab />
            <IconButton
              hierarchy='quaternary'
              size='large'
              as='a'
              href='/history/transaction/deposit'
              color='content.default.level-5'
              icon={<DocumentHistoryIcon />}
              onClick={close}
            />
          </div>
        )}
      </div>
      <Search value={keyword} onChange={setKeyword} placeholder={t('Select_asset.r250401.Search_assets')} isFull />
    </div>
  );
};
